// Copyright (c) 2021, Comsearch, Inc., All rights reserved

/**
 * @typedef {Object} callsignCascadeAggregateGroup
 * @property {Array<number>} matchedSegmentEndIds - segment end ids which should be cascaded with the trigger segment end data
 * @property {number} triggeredSegmentEndId - segment end id that was updated and has triggered the callsign cascade.
 */

/** takes the callsignCascadeData and returns a list of all matched segmentEndIds which are identified.
 * @param {Array<callsignCascadeAggregateGroup>} callsignCascadeData - this comes from Callsign Cascade redux form
 */

const getCascadedSegmentEndIds = callsignCascadeData => (
  callsignCascadeData.reduce((a, d) => (
    a.concat(...d.matchedSegmentEndIds)
  ), [])
)

export default getCascadedSegmentEndIds
